import React from "react";
import Grid from "@mui/material/Grid";
import UserCard from "./UserCard";
import images from "../../assets/landing_page/new/Frame 2095584600 (1).svg";
function CardView({ userData = [], getUsers }) {

  return (
    <div>
      <Grid container spacing={2}>
        {userData.map((user, index) => (
          <Grid item key={user.user_id}>
            <UserCard
              key={user.user_id}
              user={{
                user_id: user.user_id,
                name: user.user_name,
                image: user.uploaded_picture_path,
                user_status: user.user_status,
              }}
              getUsers={getUsers}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default CardView;
